import { Component, EventEmitter, Output } from '@angular/core';
import { DiscardChangesService } from '../core/services/discard-changes.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-discard-dialog',
  templateUrl: './discard-dialog.component.html',
  styleUrls: ['./discard-dialog.component.scss']
})
export class DiscardDialogComponent {
  @Output() submitForm: EventEmitter<void> = new EventEmitter<void>(); // Define output event

  constructor(private discardChangesService: DiscardChangesService,
    public dialog: MatDialog,    private dialogRef: MatDialogRef<DiscardDialogComponent>,

    
  ) { }

  submit() {
    this.dialogRef.close(true); 
  }

  cancelDialog() {
    this.dialogRef.close(false); 
  }
}
